<template>
  <v-expansion-panels>
    <v-expansion-panel
      v-for="egreso in egresos"
      :key="egreso.categoria"
      expand-icon="mdi-chevron-down"
    >
      <v-expansion-panel-header>
        <v-list-item-avatar class="mr-2">
          <v-icon :color="egreso.color">mdi-circle</v-icon>
        </v-list-item-avatar>
        <span>{{ egreso.categoria }}</span>
        <v-spacer></v-spacer>
        <v-chip small color="">{{ egreso.gastos.length }} gastos</v-chip>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <v-list two-line>
         <v-list-item
  v-for="e in egreso.gastos"
  :key="e.id"
  @click="handleClick(e)"
>
  <v-list-item-content>
    <v-list-item-title>
      {{ e.tipoIngresoEgreso.descripcion }}
    </v-list-item-title>
    <v-list-item-subtitle>
      {{ e.descripcion }}
    </v-list-item-subtitle>
  </v-list-item-content>

  <v-list-item-action>
    <v-icon
      :color="e.tipoIngresoEgreso.descripcion === 'BUZON' ? 'green' : 'red'"
    >
      {{
        e.tipoIngresoEgreso.descripcion === 'BUZON'
          ? 'mdi-arrow-up-thick'
          : 'mdi-arrow-down-thick'
      }}
    </v-icon>
  </v-list-item-action>

  <v-list-item-action>
    <div class="d-flex flex-column align-end">
      <span class="font-weight-bold">
        - {{ e.monto | convertPesoArg }}
      </span>
      <span class="text-caption grey--text">
        {{ moment(e.fechaAlta).format("HH:mm") }} hs
      </span>
    </div>
  </v-list-item-action>
</v-list-item>
          <v-divider></v-divider>
        </v-list>

        <v-alert
          v-if="egreso.gastos.length === 0"
          type="info"
          text
        >
          No hay gastos registrados.
        </v-alert>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>


<script>
export default {
    name: 'egresos.list',
    props: {
        egresos: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    methods: {
        handleClick(egreso) {
            this.$emit('process-egreso', egreso)
        }
    }
}
</script>

<style lang="scss" scoped></style>